//taille maximale de l'écran et de la composition

export default {
    width: 1080,
    height: 1920,
    compositionWidth: 1950,
    compositionHeight: 1950,
}